import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FormContainer, DefaultTable } from "../../shared";
import useGlobalMutation from "../../../hooks/useGlobalMutation";
import { GET_BASIC_LOGIN_APPS, UPDATE_PERMISSION } from "./query";
import { useQuery, gql } from "@apollo/client";
import { COUNTRY_LIST, Helper, clearCache } from "../../../utils";

const PermissionManager = ({ id, domains }) => {
    const { handleSubmit, watch, setValue } = useForm({
        defaultValues: { basicLoginDomains: [...domains] },
    });

    const basicLoginDomains = watch("basicLoginDomains");

    const toggleDomain = (domain) => {
        const updatedDomains = basicLoginDomains.includes(domain)
            ? basicLoginDomains.filter((item) => item !== domain)
            : [...basicLoginDomains, domain];

        setValue("basicLoginDomains", updatedDomains);
    };

    const getBasicLoginUserPermission = (val) => {
        return (
            <label className="customcheck" key={val}>
                <input
                    type="checkbox"
                    name="basicLoginDomains"
                    value={val}
                    checked={basicLoginDomains.includes(val)}
                    onChange={() => toggleDomain(val)}
                />
                <span className="checkmark"></span>
            </label>
        );
    };

    const [tableData, setTableData] = useState([]);
    const { data } = useQuery(gql(GET_BASIC_LOGIN_APPS));

    useEffect(() => {
        if (data?.allBasicAuths?.nodes.length > 0) {
            const basicLoginApps = data.allBasicAuths.nodes;
            setTableData(basicLoginApps);
        }
    }, [data]);

    const { submitMutation, loading } = useGlobalMutation(UPDATE_PERMISSION, (cache) => {
        clearCache(cache, "allBasicAuths");
        clearCache(cache, "getBasicLoginUser");
    });

    const submitAction = handleSubmit(async (data) => {
        const { basicLoginDomains } = data;

        const basicLoginAppNames = basicLoginDomains.map((item) => {
            const basicLoginAppItem = tableData
                .filter((el) => el.domainName === item)
                .map((el) => el.appName);
            return basicLoginAppItem[0];
        });

        const variables = {
            id,
            basicLoginUser: {
                basicLoginUserPermissions: basicLoginAppNames,
                domainName: basicLoginDomains,
            },
        };

        await submitMutation(
            variables,
            "updateBasicLoginUserById.basicLoginUser",
            "Successfully Update Permission"
        );
    });

    return (
        <FormContainer submitAction={() => submitAction()} loading={loading} submitBtnSm>
            <h5 className="mb-4">Update Permission</h5>
            <div className="mb-4">
                <DefaultTable
                    data={tableData}
                    headers={[
                        {
                            accessorKey: "appName",
                            header: "App Name",
                            cell: (cell) => Helper.getAppNameById(cell.getValue()),
                        },
                        {
                            accessorKey: "country",
                            header: "Country",
                            cell: (cell) =>
                                cell.getValue() ? COUNTRY_LIST[cell.getValue()] : "All",
                        },
                        {
                            accessorKey: "domainName",
                            header: "Domain Name",
                        },
                        {
                            accessorKey: "applicationId",
                            header: "Permission",
                            cell: ({ row }) =>
                                getBasicLoginUserPermission(row.getValue("domainName")),
                        },
                    ]}
                />
            </div>
        </FormContainer>
    );
};

export default PermissionManager;
